var _path, _path2, _path3, _path4, _g, _path5, _path6, _path7, _path8, _g2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFacadeSimilarDesktop(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 212,
    height: 325,
    viewBox: "0 0 212 325",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.8031 0L0.856445 172.427H42.1516L75.0059 0H16.8031Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4717 0H79.9669L62.5918 72.5652L82.642 172.427H117.886L99.4717 0Z",
    fill: "white"
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_318:3992",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 118,
    height: 173
  }, _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M16.8031 0L0.856445 172.427H42.1516L75.0059 0H16.8031Z",
    fill: "#A98AD1"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M99.4717 0H79.9669L62.5918 72.5652L82.642 172.427H117.886L99.4717 0Z",
    fill: "#A98AD1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_318:3992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M-4.82292 -7.62952C5.29162 4.29079 25.5207 33.888 25.5207 56.9146C25.5207 79.9411 -7.03184 51.8557 -23.3081 34.9347",
    stroke: "#949DF0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M59.0905 215.152C36.202 169.375 17.1283 109.865 23.9948 86.9764C30.8614 64.0879 36.9649 160.22 -4.23438 98.4207",
    stroke: "#949DF0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M95.7114 189.975C95.7114 165.56 97.2373 119.325 103.341 129.702C110.97 142.672 114.785 186.923 126.229 189.975",
    stroke: "#949DF0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 15.6021,
    cy: 151.827,
    r: 6.11655,
    stroke: "#949DF0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M63.6688 123.598C81.9796 108.339 101.053 106.813 70.5353 144.197M68.2465 -5.34077C64.686 4.32327 55.2763 27.7713 46.1209 44.251C34.6767 64.8506 34.6763 11.4441 49.9353 -18.3109",
    stroke: "#949DF0",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M62.1423 123.598C72.5693 107.067 93.2707 67.9026 92.6603 43.4882C91.8974 12.9702 65.9571 114.443 119.364 43.4882",
    stroke: "#949DF0",
    strokeWidth: 1.5
  }))), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M167.582 152.66L135.014 323.587H95.1619L110.97 152.66H167.582Z",
    stroke: "white",
    strokeWidth: 1.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M156.843 224.489L174.041 152.66H192.28L210.534 323.587H176.739L156.843 224.489Z",
    stroke: "white",
    strokeWidth: 1.5
  })), /*#__PURE__*/React.createElement("mask", {
    id: "mask1_318:3992",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 94,
    y: 151,
    width: 118,
    height: 174
  }, _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M110.286 151.91L94.3394 324.337H135.634L168.489 151.91H110.286Z",
    fill: "#A98AD1"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M192.955 151.91H173.45L156.075 224.475L176.125 324.337H211.369L192.955 151.91Z",
    fill: "#A98AD1"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask1_318:3992)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M88.66 144.28C98.7745 156.201 119.004 185.798 119.004 208.824C119.004 231.851 86.4511 203.766 70.1748 186.845",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M152.574 367.062C129.685 321.285 110.612 261.775 117.478 238.886C124.345 215.998 130.448 312.129 89.249 250.33",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M189.195 341.884C189.195 317.47 190.721 271.235 196.825 281.611C204.454 294.582 208.269 338.833 219.713 341.884",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 109.085,
    cy: 303.737,
    r: 6.11655,
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M157.151 275.508C175.462 260.249 194.536 258.723 164.018 296.107M161.729 146.569C158.169 156.233 148.759 179.681 139.604 196.161C128.159 216.761 128.159 163.354 143.418 133.599",
    stroke: "white",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    d: "M155.626 275.508C166.053 258.977 186.754 219.812 186.144 195.398C185.381 164.88 159.44 266.352 212.847 195.398",
    stroke: "white",
    strokeWidth: 1.5
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFacadeSimilarDesktop);
export default __webpack_public_path__ + "static/media/facade-similar-desktop.da1ef792.svg";
export { ForwardRef as ReactComponent };